
<template>
  <div :style="{direction:$t('direction')}" class="site-wrapper">

    <Header></Header>

    <div class="fast-exchange">

      <div v-if="step === 1" class="d-flex justify-content-center flex-column align-items-center" style="height:100%">

        <div class="ar-form-group">
          <label>لطفا شماره تلفن خود را وارد کنید</label>
          <the-mask class="ar-form-control text-center latin-input-3" :masked="true" v-model="form.mobile_number" placeholder="0 9 - - - - - - - - -" :mask="[
            '09#########'
          ]" />
          <div v-if="errors.mobile_number" class="ar-alert danger round my-2">
            <small>لطفا شماره تلفن خود را به درستی وارد نمایید.</small>
          </div>
        </div>

        <div class="text-center">
          <button v-if="!form.mobile_number" class="ar-btn size-md round primary disabled">ادامه</button>
          <button v-else class="ar-btn size-md round primary" @click="checkRegistration()">ادامه</button>
        </div>

      </div>

      <div v-if="step === 2" class="d-flex justify-content-center flex-column align-items-center" style="height:100%">

        <template v-if="!is_registerd">
          
          <div class="ar-form-group my-4">
            <label>نام و نام خانوادگی</label>
            <input class="ar-form-control text-center latin-input-3" v-model="form.fullname"/>
            <div v-if="errors.fullname" class="ar-alert danger round my-2">
              <small>نام و نام خانوادگی اجباری است.</small>
            </div>
          </div>

          <div class="ar-form-group my-4">
            <label>کد ملی</label>
            <the-mask class="ar-form-control text-center latin-input-3" :masked="true" v-model="form.national_code" :mask="[
              '##############'
            ]" />
            <div v-if="errors.national_code" class="ar-alert danger round my-2">
              <small>{{errors.national_code[0]}}</small>
            </div>
          </div>
          
        </template>
        <div style="font-size:13px;">
          <template v-if="user_data">{{ user_data }}</template><template v-else>کاربر</template> عزیز , درخواست شما از طریق سرویس وندار بانک آینده انجام می گیرد. برای استفاده از سرویس وندار نیاز است که یک بار در این سرویس ثبت نام فرمایید و بعد از آن فقط با یک کلیک از خدمات ارزینه بهره مند گردید.
        </div>
          
        <div class="ar-form-group my-4">
          <label>مقدار واریزی</label>
          <!-- <money v-model="form.paid_amount" class="ar-form-control text-center" @input.native="buy_feild_changed(true)"></money> -->
          <input onclick="this.select()" class="ar-form-control text-center" type="number" @keypress="just_float($event)" v-model="form.paid_amount" @input="buy_feild_changed(true)">
          <!-- <div v-if="deposit.paid_currency == 'IRR'"> -->
            <small v-if="form.paid_amount">معادل {{formatPrice(form.paid_amount)}} تومان</small>
          <!-- </div> -->
          <div v-if="errors.paid_amount" class="ar-alert danger round my-2">
            <small>مقدار واریزی باید وارد شود.</small>
          </div>
        </div>
        
        <div class="ar-form-group my-4">
          <label>مقدار تتر دریافتی</label>
          <input onclick="this.select()" class="ar-form-control text-center" type="number" @keypress="just_float($event)" v-model="form.received_amount" @input="buy_feild_changed(false)">
        </div>

        <div class="ar-form-group">
          <label>شبکه انتقال</label>
          <select class="ar-form-control text-center font-en" v-model="form.network">
            <option value="TRC20">TRC20</option>
            <option value="ERC20">ERC20</option>
            <option value="BEP20">BEP20</option>
            <option value="BEP2">BEP2</option>
          </select>
          <div v-if="errors.network" class="ar-alert danger round my-2">
            <small>انتخاب شبکه انتقال اجباری است.</small>
          </div>
        </div>
        
        <div class="ar-form-group">
          <label>آدرس ولت</label>
          <input class="ar-form-control text-center latin-input-2" v-model="form.address">
          <div v-if="errors.address" class="ar-alert danger round my-2">
            <small>وارد کردن آدرس کیف پول اجباری است.</small>
          </div>
        </div>

        <div class="text-center">
          <button class="ar-btn size-md round primary" @click="submitFastBuyReq()">ادامه</button>
        </div>

      </div>
      
    </div>
    <Footer></Footer>
    
    <Modal :open="fast_buy_modal" @close="fast_buy_modal = false">
      
    </Modal>

  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
import Modal from '../components/Modal.vue'
import {TheMask} from 'vue-the-mask'
export default {
  name: 'FastBuy',
  components:{
    Modal,
    Header,
    Footer,
    TheMask
  },
  data : () => ({
    form : {},
    errors : {},
    user_data:null,
    step:1,
    SlideShowTimer:null,
    fast_buy_modal:false,
    is_registerd:false,
  }),
  methods: {
    buy_feild_changed(type)
    {
      const isNumeric = /^[-+]?(\d+|\d+\.\d*|\d*\.\d+)$/;
      if(type){

        if(this.form.paid_amount){
          const amount =  this.form.paid_amount.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
          // const amount = this.form.paid_amount.replace(/,/g, "");
          if(isNumeric.test(amount)) {
            const number = parseFloat(amount / this.state_prices.sale_price)
            this.form.received_amount = parseFloat(number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
            // this.form.paid_amount = this.formatPrice(amount)
          }else{
            this.form.received_amount = null
            this.form.paid_amount = null
          }
        }else{
          this.form.received_amount = null
        }

      }else{
        if(this.form.received_amount){
          this.form.received_amount = this.form.received_amount.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
          if (isNumeric.test(this.form.received_amount)) {
            this.form.paid_amount = parseInt(this.form.received_amount * this.state_prices.sale_price)
          }else{
            this.form.paid_amount = null
            this.form.received_amount = null
          }
        }else{
          this.form.paid_amount = null
        }
      }

    },
    checkRegistration (){
      this.activeLoading(true)
      this.$axios.post(`check_is_registered` , this.form)
      .then( res => {
        if(res.data.data !== 0){
          this.user_data = res.data.data
          this.is_registerd = true
        }
        this.activeLoading(false)
        this.step = 2;
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });
    },
    submitFastBuyReq (){
      if(this.is_registerd === false){
        if(!this.form.national_code){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: 'کد ملی الزامی می باشد.'
          });
          return false
        }
        if(!this.checkCodeMeli(this.form.national_code)){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: 'کد ملی صحیح نمی باشد.'
          });
          return false
        }
      }
      this.activeLoading(true)
      this.errors = {}
      this.$axios.post(`submitFastBuyReq` , this.form)
      .then( res => {
        location.href = res.data.data
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });
    },
    checkCodeMeli(code)
    {
      var L=code.length;
    
      if(L<8 || parseInt(code,10)==0) return false;
      code=('0000'+code).substr(L+4-10);
      if(parseInt(code.substr(3,6),10)==0) return false;
      var c=parseInt(code.substr(9,1),10);
      var s=0;
      for(var i=0;i<9;i++)
        s+=parseInt(code.substr(i,1),10)*(10-i);
        s=s%11;
      return (s<2 && c==s) || (s>=2 && c==(11-s));
      return true;
    }
  },
  mounted() {
    this.activeLoading(false)
    // this.getRealTimePrice()
  }
}
</script>